<template>
  <div class="product_module">
    <div class="enMainTitle">Products Exhibition</div>
    <div>
      <el-row>
        <el-col :span="6" v-for="(product,index) in productArr" :key="index">
          <div class="list_imgs" @click="viewProduct(product.pid)">
            <img :src="product.path" alt="" width="100%" height="280">
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="pro_space">
      <el-button class="enmore_btn h_pro_more" @click="productModule">
        more<i class="el-icon-right el-icon--right"></i>
      </el-button>
    </div>
  </div>
</template>
<script>
import { productList } from '@/api/enFrontApi/product';
export default {
  data() {
    return {
      productArr: [
        { path: '../../../../static/img/product/vehicle-1.png', index: 1 },
        { path: '../../../../static/img/product/vehicle-2.png', index: 2 },
        { path: '../../../../static/img/product/vehicle-3.png', index: 3 },
        { path: '../../../../static/img/product/vehicle-4.png', index: 4 },
        { path: '../../../../static/img/product/vehicle-5.png', index: 5 },
        { path: '../../../../static/img/product/vehicle-6.png', index: 6 },
        { path: '../../../../static/img/product/vehicle-7.png', index: 7 },
        { path: '../../../../static/img/product/vehicle-8.png', index: 8 }
      ]
    };
  },
  created() {
    this.getProductList();
  },
  methods: {
    getProductList() {
      productList(0).then(res => {
        if (res.data.length > 0) {
          this.productArr = [];
          let showArr = res.data.slice(0, 8);
          showArr.forEach(item => {
            if (item.picMain) {
              let tempObj = { path: '', pid: 0, name: '' };
              tempObj.name = item.proTitle;
              tempObj.path = item.picMain;
              tempObj.pid = item.proId;
              this.productArr.push(tempObj);
            }
          });
        }
      });
    },
    productModule(item) {
      this.$router.push({ name: 'iaic2019en/product' });
    },
    viewProduct(productId) {
      this.$router.push({
        name: 'iaic2019en/productInfo',
        params: {
          productId: productId,
          proType: 0
        }
      });
    }
  }
};
</script>
<style scoped>
.product_module {
  width: 100%;
  text-align: center;
}

.list_imgs {
  overflow: hidden;
  width: 100%;
  height: 100%;
}
.list_imgs img:hover {
  cursor: pointer;
  transform: scale(1.2);
}
.h_pro_more {
  background-color: #e9f5f7;
  margin-top:20px;
}
.h_pro_more:hover {
  background-color: #00697f;
}
</style>



// WEBPACK FOOTER //
// src/pages/enViews/home/homeProduct.vue